import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  AutoComplete,
  Button,
  Cascader,
  Checkbox,
  Form,
  Input,
  InputNumber,
  Select,
  Col,
  Row,
  Radio,
  Upload,
} from "antd";
import { useParams } from "react-router-dom";

import CustomUpload from "../../components/Upload";
import SUpload from "../../components/S3Upload";
import styles from "./index.modules.less";
import { saveSoftMgr } from "../../service/register";
import { message } from "../../components/Message";

const { Option } = Select;

const residences = [
  {
    value: "zhejiang",
    label: "Zhejiang",
    children: [
      {
        value: "hangzhou",
        label: "Hangzhou",
        children: [
          {
            value: "xihu",
            label: "West Lake",
          },
        ],
      },
    ],
  },
  {
    value: "jiangsu",
    label: "Jiangsu",
    children: [
      {
        value: "nanjing",
        label: "Nanjing",
        children: [
          {
            value: "zhonghuamen",
            label: "Zhong Hua Men",
          },
        ],
      },
    ],
  },
];

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

const checkImagestatus = (urls) => {
  let checked = true;
  urls.forEach((item) => {
    if (!item?.response?.pic_url) {
      checked = false;
    }
  });
  return checked
};

const Register = () => {
  const [form] = Form.useForm();
  const { config, softForm, oss } = useSelector((state) => state);
  const navigate = useNavigate();
  const { id } = useParams();
  console.log("config", config);
  console.log("softForm is", softForm);
  const dispatch = useDispatch();

  const onFinish = (values) => {
    console.log("Received values of form: ", values);

    if (!checkImagestatus(values.certificate_pic)) {
      message.show({
        type: 'error',
        content: '请重新上传资质'
      })
      return;
    }

    if (!checkImagestatus(values.logo_pic)) {
      message.show({
        type: 'error',
        content: '请重新上传logo'
      })
      return;
    }

    if (!checkImagestatus(values.running_pic)) {
      message.show({
        type: 'error',
        content: '请重新上传截图'
      })
      return;
    }

    values.certificate_pic = values.certificate_pic
      .map((item) => item.response.pic_url)
      .join(",");
    values.logo_pic = values.logo_pic
      .map((item) => item.response.pic_url)
      .join(",");
    values.running_pic = values.running_pic
      .map((item) => item.response.pic_url)
      .join(",");

    values.os_osbit = values?.os_osbit.join(",");
    values.run_envs = values?.run_envs.join(",");
    values.free_trial_days = Number(values?.free_trial_days);
    values.app_id = softForm.app_id;
    values.id = softForm.id;

    if (values.real_file_name) {
      values.real_file_name = values.real_file_name[0].name;
    }

    if (oss.app_pkg_key) {
      values.app_pkg_key = oss.app_pkg_key;
    }

    // if (softForm.app_pkg_key) {
    //   values.app_pkg_key = softForm.app_pkg_key;
    // }

    saveSoftMgr({ ...values })
      .then(() => {
        message.show({
          type: "success",
          content: "保存成功！",
        });
        navigate("/view/home");
      })
      .catch((e) => {
        console.error(e);
        message.show({
          type: "error",
          content: "网络错误！",
        });
      });
  };

  useEffect(() => {
    dispatch.config.setConfigAsync();
  }, []);

  useEffect(() => {
    // 获取最新编辑数据
    dispatch.softForm.setLastSoftInfoAsync({ id });
    return () => {
      dispatch.softForm.clearInfo();
      dispatch.oss.clearInfo();
    };
  }, [id]);

  useEffect(() => {
    const keys = Object.keys(softForm);
    if (keys && keys.length) {
      const {
        logo_pic,
        running_pic,
        certificate_pic,
        os_osbit,
        run_envs,
        real_file_name,
        app_cate_id
      } = softForm;
      let newSoftForm = {
        ...softForm,
        logo_pic: logo_pic?.split(",")?.map((item, index) => {
          return {
            uid: index,
            type: "image/png",
            response: { pic_url: item },
            name: `logo.png`,
            status: "done",
          };
        }),
        running_pic: running_pic?.split(",")?.map((item, index) => {
          return {
            uid: index,
            type: "image/png",
            response: { pic_url: item },
            name: `running_pic-${index}.png`,
            status: "done",
          };
        }),
        certificate_pic: certificate_pic?.split(",")?.map((item, index) => {
          return {
            uid: index,
            type: "image/png",
            response: { pic_url: item },
            name: `certificate_pic-${index}.png`,
            status: "done",
          };
        }),
        real_file_name: real_file_name?.split(",")?.map((item) => {
          return {
            uid: -1,
            type: "image/png",
            response: item,
            name: item,
            status: "done",
          };
        }),

        os_osbit: os_osbit?.split(","),
        run_envs: run_envs?.split(","),
      };
      if (!logo_pic) {
        newSoftForm.logo_pic = [];
      }
      if (!running_pic) {
        newSoftForm.running_pic = [];
      }

      if (!certificate_pic) {
        newSoftForm.certificate_pic = [];
      }

      if (!real_file_name) {
        newSoftForm.real_file_name = [];
      }

      if (!app_cate_id) {
        newSoftForm.app_cate_id = config?.soft_cate?.[0]?.id
      }

      if (softForm.app_pkg_key) {
        dispatch.oss.setOssObj({
          app_pkg_key: softForm.app_pkg_key,
        })
      }

      console.log("newSoftForm is", newSoftForm);
      form.setFieldsValue(newSoftForm);

      // form.setFieldsValue({
      //   os_osbit: [64],
      //   run_envs: []
      // })
    }
  }, [softForm]);


  const [autoCompleteResult, setAutoCompleteResult] = useState([]);
  const onWebsiteChange = (value) => {
    if (!value) {
      setAutoCompleteResult([]);
    } else {
      setAutoCompleteResult(
        [".com", ".org", ".net"].map((domain) => `${value}${domain}`)
      );
    }
  };

  const websiteOptions = autoCompleteResult.map((website) => ({
    label: website,
    value: website,
  }));

  return (
    <div className={styles.registerWrapper}>
      <div onClick={() => navigate(-1)} className={styles.back}>
        {" "}
        {`<返回`}
      </div>
      <Form
        form={form}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
        initialValues={softForm}
        labelCol={{ style: { width: "150px" } }}
      >
        <Row className="first-row">
          <Col>
            <Form.Item
              name="app_name"
              label="软件名称"
              // disable={softForm.app_name ? true : false}
              rules={[
                {
                  required: true,
                  message: "请输入软件名称!",
                },
              ]}
            >
              <Input
                disabled
                placeholder="10个汉字内，英文字符不超过20个"
                className="appinfo-input"
              />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item
              name="app_version"
              label="软件版本"
              rules={[
                {
                  required: true,
                  message: "请输入软件版本!",
                },
              ]}
            >
              <Input
                placeholder="请输入版本号，例如：1.0.0.1"
                className="appinfo-input"
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          name="upload_type"
          label="提交方式"
          rules={[
            {
              required: true,
              message: "请选择提交方式！",
            },
          ]}
          initialValue={0}
          hasFeedback
        >
          <Radio.Group>
            <Radio value={0}> 安装包URL链接 </Radio>
            <Radio value={1}> 上传文件 </Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item dependencies={["upload_type"]}>
          {({ getFieldValue }) => {
            const type = getFieldValue("upload_type");
            if (type == "0") {
              return (
                <Form.Item
                  colon={false}
                  labelCol={{ style: { width: "150px" } }}
                  label=" "
                  name="soft_download_url"
                  rules={[
                    {
                      required: true,
                      message: "请输入下载链接!",
                    },
                    {
                      message: "请输入https地址,文件名后缀exe,msi,zip",
                      pattern: /^(https):\/\/.*\.(exe|zip|msi)$/,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              );
            } else {
              return (
                <Form.Item
                  colon={false}
                  labelCol={{ style: { width: "150px" } }}
                  label=" "
                  name="real_file_name"
                  valuePropName="fileList"
                  rules={[
                    {
                      required: true,
                      message: "请上传文件!",
                    },
                  ]}
                >
                  {/* <Upload action="/upload.do" listType="picture-card">
                    <div>
                      <PlusOutlined />
                      <div style={{ marginTop: 8 }}>Upload</div>
                    </div>
                  </Upload> */}
                  <SUpload
                    accept=".zip, .mis, .exe"
                    tips="安装包不能超过512M，提交格式为zip，msi，exe"
                    maxCount={1}
                    name="real_file_name"
                    form={form}
                    softForm={softForm}
                  ></SUpload>
                </Form.Item>
              );
            }
          }}
        </Form.Item>

        <Form.Item
          name="logo_pic"
          label="上传logo"
          hasFeedback
          valuePropName="fileList"
          getValueFromEvent={(e) => {
            return e;
          }}
          rules={[
            {
              required: true,
              message: "请上传logo!",
            },
          ]}
        >
          <CustomUpload
            key={123}
            accept=".jpg, .jpeg, .png"
            tips="图片大小不能超过2M，尺寸为72*72px，格式为jpg,jpeg,png"
            maxCount={1}
            name="logo_pic"
            form={form}
            width={72}
            height={72}
            size={2}
          ></CustomUpload>
        </Form.Item>

        <Form.Item
          name="running_pic"
          label="上传截图"
          valuePropName="fileList"
          getValueFromEvent={(e) => {
            return e;
          }}
          hasFeedback
          rules={[
            {
              required: true,
              message: "请上传截图!",
            },
          ]}
        >
          {/* <Upload fileList>12312</Upload> */}
          <CustomUpload
            form={form}
            name="running_pic"
            tips="图片大小不能超过5M，尺寸为1000*666px，格式为jpg,jpeg,png，最多5张"
            maxCount={5}
            accept=".jpg, .jpeg, .png"
            width={1000}
            height={666}
            size={5}
          ></CustomUpload>
        </Form.Item>

        <Form.Item
          name="certificate_pic"
          label="上传资质"
          valuePropName="fileList"
          getValueFromEvent={(e) => {
            return e;
          }}
          // dependencies={["password"]}
          hasFeedback
          rules={[
            {
              required: true,
              message: "请上传资质!",
            },
          ]}
        >
          <CustomUpload
            tips="请务必提交软件著作权证书，如有其他资质，请一并提交，图片大小不能超过5M，格式为jpg,jpeg,png"
            maxCount={5}
            name="certificate_pic"
            form={form}
            accept=".jpg, .jpeg, .png"
            size={5}
          ></CustomUpload>
        </Form.Item>

        <Form.Item
          name="feature"
          label="软件介绍"
          // tooltip="What do you want others to call you?"
          rules={
            [
              {
                required: true,
                message: "请填写软件介绍!",
                whitespace: true,
              },
            ]
          }
        >
          <Input.TextArea
            className="appinfo-feature"
            showCount
            placeholder="软件介绍尽量详细，请勿填写带有广告性质的网站链接和联系方式，不超过300字"
            maxLength={1000}
          />
        </Form.Item>

        <Form.Item
          name="run_envs"
          label="支持运行的系统版本"
          rules={
            [
              {
                required: true,
                validator: (_, value) => {
                  const validValues = value.filter(item => item && item.trim());
                  if (validValues.length === 0) {
                    return Promise.reject(new Error("请选择系统环境!"));
                  }
                  return Promise.resolve();
                }
              }
            ]
          }
        >
          <Checkbox.Group>
            {config?.system_env?.map((item, index) => (
              <Checkbox
                key={item.id}
                value={`${item.id}`}
                style={{ lineHeight: "32px" }}
              >
                {item.name}
              </Checkbox>
            ))}
          </Checkbox.Group>
        </Form.Item>

        <Form.Item
          name="os_osbit"
          label="支持运行的系统位数"
          rules={[
            {
              required: true,
              validator: (_, value) => {
                const validValues = value.filter(item => item && item.trim());
                if (validValues.length === 0) {
                  return Promise.reject(new Error("请选择操作系统位数!"));
                }
                return Promise.resolve();
              }
            },
          ]}
        >
          <Checkbox.Group>
            <Checkbox value={"32"} style={{ lineHeight: "32px" }}>
              32位
            </Checkbox>
            <Checkbox value={"64"} style={{ lineHeight: "32px" }}>
              64位
            </Checkbox>
          </Checkbox.Group>
        </Form.Item>

        <Form.Item
          name="app_cate_id"
          label="软件类型"
          rules={
            [
              { required: true, message: "请选择软件类型!" }
            ]
          }
        >
          <Select className="appinfo-app_cate" placeholder="请选择软件类型！">
            {config?.soft_cate?.map((item, index) => (
              <Option key={item.id} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* <Form.Item
          name="callBackUrl"
          label="回调地址"
          rules={[{ required: true, message: "Please input website!" }]}
        >
          <AutoComplete
            options={websiteOptions}
            onChange={onWebsiteChange}
            placeholder="website"
          >
            <Input />
          </AutoComplete>
        </Form.Item> */}

        <Form.Item
          name="language"
          label="软件语言"
          rules={
            [
              {
                required: true, validator: (_, value) => {

                  const validLanguageIds = config?.language?.map(item => item.id) || [];
                  if (validLanguageIds.length > 0 && !validLanguageIds.includes(value)) {
                    return Promise.reject(new Error("请选择软件语言!"));
                  }
                  return Promise.resolve();
                }
              }
            ]
          }
        >
          <Radio.Group>
            {config?.language?.map((item, index) => {
              return (
                <Radio key={item.id} value={item.id}>
                  {" "}
                  {item.name}{" "}
                </Radio>
              );
            })}
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="fee"
          label="付费信息"
          className="appinfo-free-item"
          rules={
            [
              {
                required: true, validator: (_, value) => {

                  const validLanguageIds = config?.language?.map(item => item.id) || [];
                  if (validLanguageIds.length > 0 && !validLanguageIds.includes(value)) {
                    return Promise.reject(new Error("请选择付费方式!"));
                  }
                  return Promise.resolve();
                }
              }
            ]
          }
        >
          <Radio.Group>
            <Radio value={2}> 免费 </Radio>
            <Radio value={1}> 收费 </Radio>
            <Radio value={3}> 试用 </Radio>
            <Form.Item
              style={{ display: "inline-block" }}
              dependencies={["fee"]}
            >
              {({ getFieldValue }) => {
                const fee = getFieldValue("fee");
                let disable;
                if (fee == "3") {
                  disable = false;
                } else {
                  disable = true;
                }
                console.log("disable si", disable);
                return (
                  <Form.Item name="free_trial_days">
                    <Input
                      className="appinfo-free_trial_days"
                      disabled={disable}
                    ></Input>
                  </Form.Item>
                );
              }}
            </Form.Item>
            <Radio value={4}> 部分功能收费 </Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="new_feature"
          label="更新日志"
          // tooltip="What do you want others to call you?"
          rules={
            [
              {
                required: true,
                message: "请填写更新日志!",
                whitespace: true,
              },
            ]
          }
        >
          <Input.TextArea
            className="appinfo-newfeature"
            showCount
            placeholder="请填写更新日志，不超过300字"
            maxLength={300}
          />
        </Form.Item>

        <Form.Item
          name="install_params"
          label="静默安装参数"
          // tooltip="What do you want others to call you?"
          rules={
            [
              // {
              //   required: true,
              //   message: "请填写静默安装参数!",
              //   whitespace: true,
              // },
            ]
          }
        >
          <Input.TextArea
            placeholder="静安装参数：如:/s或者VERYSILENT/SUPPRESSMSGBOXES/NORESTART-，添加参数后执行安装exe文件即可静默安装，不显示安装界面
"
            className="appinfo-params"
            showCount
            maxLength={100}
          />
        </Form.Item>

        <Form.Item {...tailFormItemLayout}>
          <Button className="btn-cancel" onClick={() => navigate(-1)}>
            取消
          </Button>
          <Button className="btn-add" type="primary" htmlType="submit">
            提交审核
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Register;
